import type {
  StoryImportReviewBundle,
  StoryImportReviewElement,
} from "@/features/story-import/story-import.types";
import { buildProjectStoryImportReviewRoute } from "@/features/story-import/storyImportMappers";

export interface StoryImportReviewEditState {
  element: StoryImportReviewElement;
  importJobId: string;
  kind: "story-import-review-edit";
  projectId: string;
  reviewRoute: string;
  sourceFileName: string;
  storyId: string;
}

export function buildStoryImportReviewEditState(
  bundle: Pick<StoryImportReviewBundle, "jobId" | "projectId" | "sourceFileName" | "storyId">,
  element: StoryImportReviewElement,
): StoryImportReviewEditState {
  return {
    element,
    importJobId: bundle.jobId,
    kind: "story-import-review-edit",
    projectId: bundle.projectId,
    reviewRoute: buildProjectStoryImportReviewRoute(bundle.projectId, bundle.jobId),
    sourceFileName: bundle.sourceFileName,
    storyId: bundle.storyId,
  };
}

export function getStoryImportReviewEditHref(
  projectId: string,
  elementType: StoryImportReviewElement["elementType"],
) {
  switch (elementType) {
    case "chapter":
      return `/projects/${projectId}/stories`;
    case "character":
    case "item":
      return `/projects/${projectId}/entities`;
    case "location":
    case "world_system":
    case "governance":
    case "story_spine":
      return `/projects/${projectId}/lore`;
    case "timeline_event":
      return `/projects/${projectId}/timeline`;
    default:
      return `/projects/${projectId}`;
  }
}

export function isStoryImportReviewEditState(value: unknown): value is StoryImportReviewEditState {
  if (!value || typeof value !== "object") {
    return false;
  }

  const candidate = value as Partial<StoryImportReviewEditState>;
  return candidate.kind === "story-import-review-edit"
    && typeof candidate.importJobId === "string"
    && typeof candidate.projectId === "string"
    && typeof candidate.reviewRoute === "string"
    && typeof candidate.sourceFileName === "string"
    && typeof candidate.storyId === "string"
    && Boolean(candidate.element && typeof candidate.element === "object");
}
